import { Component, Inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { finalize } from 'rxjs';
import { NotificationService } from 'src/app/services/notification.service';
import { environment } from 'src/environments/environment';
import { helper } from 'src/environments/helper';
import { PrioritatiService } from '../prioritati.service';
import { PrioritateUpdate } from '../prioritati.interface';
import { notDefaultValidator } from 'src/app/validators/not-default';

@Component({
    selector: 'app-edit-prioritati',
    templateUrl: './edit-prioritati.component.html',
    styleUrls: ['./edit-prioritati.component.scss']
})
export class EditPrioritatiComponent {
    errorTitle: string = environment.config.customNotifications.headers.error;
    errorIcon: string = environment.config.customNotifications.icons.error;
    errorType: string = environment.config.customNotifications.icons.error;
    helper = helper;

    isLoading = false;

    zileOptions: { name: string; id: number }[] = [
        { name: '-- Alegeți --', id: -1, },
        { name: 'Zile calendaristice', id: 1 },
        { name: 'Zile lucrătoare', id: 2, }
    ];

    form: FormGroup = new FormGroup({
        name: new FormControl(this.data.name, [Validators.required]),
        slug: new FormControl(this.data.slug, [Validators.required]),
        color: new FormControl(this.data.color, [Validators.required]),
        time: new FormControl(this.data.time, [Validators.required, Validators.min(1)]),
        type: new FormControl(this.data.type, [Validators.required, notDefaultValidator('-1')]),
        observatii: new FormControl('', []),
    });

    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: any,
        private dialogRef: MatDialogRef<EditPrioritatiComponent>,
        private prioritatiService: PrioritatiService,
        private notificationService: NotificationService,
    ) { }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    submitForm() {
        this.isLoading = true;

        const { name, slug, color, time, type, observatii } = this.form.value;
        const payload: PrioritateUpdate = {
            id: this.data.id,
            name,
            slug,
            color,
            time,
            type,
            observatii
        };

        this.prioritatiService
            .update(payload)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: () => {
                    this.dialogRef.close({ success: true });
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        helper.dialogConfig.headers.errorAtentie,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }
}
